import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { BaseComponent } from '../../../components/BaseComponent';
import { Modal, ModalControls } from '../../../components/Modal';
import { Button } from '../../../components/Buttons';
import { deleteProductTask } from '../actions';

const ActionsContainer = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

const IconWrapper = styled.div`
  color: ${props => (props?.color === 'green' ? '#11ab79' : props?.color === 'orange' ? '#FC9629' : '#d50046')};
`;

export class ProductTaskActionsContainerComp extends BaseComponent {
  onClickDeleteBtn(e) {
    this.setState({ removeTaskConfirmation: true });
  }

  renderConfirmationModal() {
    if (!this.state.removeTaskConfirmation) return '';

    return (
      <Modal
        onClose={this.setStateFn({ removeTaskConfirmation: false })}
        title={this.lbl(`product.details.tasks.removeConfirmationTitle`)}
      >
        <ModalControls>
          <Button
            onClick={() => {
              this.removeTask();
              this.setState({ removeTaskConfirmation: false });
            }}
            primary
          >
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.setStateFn({ removeTaskConfirmation: false })}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  removeTask() {
    this.props.delete();
  }

  render() {
    return (
      <>
        <ActionsContainer>
          <IconWrapper color="red">
            <div
              onClick={evt => {
                evt.stopPropagation();
                this.onClickDeleteBtn(evt);
              }}
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faTimesCircle} />
            </div>
          </IconWrapper>
        </ActionsContainer>
        {this.renderConfirmationModal()}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    delete() {
      dispatch(deleteProductTask(ownProps.product_id, ownProps.task?.name));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export const ProductTaskActionsContainer = compose(withConnect, withRouter)(ProductTaskActionsContainerComp);
